import { render, staticRenderFns } from "./CoverInfo.vue?vue&type=template&id=75a94f3e"
import script from "./CoverInfo.vue?vue&type=script&lang=js"
export * from "./CoverInfo.vue?vue&type=script&lang=js"
import style0 from "./CoverInfo.vue?vue&type=style&index=0&id=75a94f3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports